import { Quill } from 'react-quill';

const ListItemFormat = Quill.import('formats/list/item');
const Parchment = Quill.import('parchment');

const blockFormats = ['font', 'size', 'bold', 'italic', 'color', 'background'];

class CustomFontAttributor extends Parchment.Attributor.Style {
  constructor(styleName, keyName, options) {
    super(styleName, keyName, options);
    this.customKeyName = this.keyName.replaceAll('custom-', '');
  }

    add = (node, value) => {
      if (!this.canAdd(node, value)) return false;
      let customValue = value;
      if (this.customKeyName === '--bold') {
        customValue = value === true || value === 'true' ? '700' : 'normal';
      } else if (this.customKeyName === '--italic') {
        customValue = value === true || value === 'true' ? 'italic' : 'normal';
      } else if (this.customKeyName === '--heading') {
        customValue = value ? JSON.stringify(value) : '{}';
      }
      node.style.setProperty(this.customKeyName, customValue);
      return true;
    };

    remove = (node) => {
      node.style.setProperty(this.customKeyName, '');
      if (!node.getAttribute('style')) {
        node.removeAttribute('style');
      }
    };

    value = (node) => {
      var value = node.style.getPropertyValue(this.customKeyName);
      if (this.customKeyName === '--heading') {
        value = JSON.parse(value);
      }
      return this.canAdd(node, value) ? value : '';
    };
}

const Break = Quill.import('blots/break');
const TextBlot = Quill.import('blots/text');
class CustomBreakBlot extends Break {
  static create(data) {
    const node = super.create();
    console.log("Break blot created here!! ", data);
    return node;
  }

  insertInto(parent, ref) {
    console.log("insertInto of break blot :: ", this);
    super.insertInto(parent, ref);
  }
}

// CustomBreakBlot.tagName = 'HR';

const Block = Quill.import('blots/block');

class CustomBlockBlot extends Block {
  previousChildIsBreak = false;

  static create(data) {
    const node = super.create();
    return node;
  }

  insertBefore(...rest) {
    const value = super.insertBefore(...rest);
    const currentFormats = this.formats();
    if (Object.keys(currentFormats).length >= 7) {
      if (rest[0].parent instanceof Block) {
        if (this.previousChildIsBreak && rest[0] instanceof TextBlot) {
          Object.keys(currentFormats).forEach(format => {
            this.formatAt(0, rest[0].length(), format.replaceAll('block-', ''), currentFormats[format] === 'normal' ? false : currentFormats[format]);
          });
          this.previousChildIsBreak = false;
        } else if (rest[0] instanceof Break) {
          this.previousChildIsBreak = true;
        }
      }
    }
    return value;
  }

  formatAt(...rest) {
    const currentFormats = this.formats();
    if (Object.keys(currentFormats).length >= 7) { // TODO : Increase count as the number of block level formats increase
    if (this.children.tail?.text === undefined && blockFormats.includes(rest[2])) {
      if (rest[0] === 0) {
        this.format(`block-${rest[2]}`,`${rest[3]}`);
      }
    }
    }
    return super.formatAt(...rest);
  }
}

console.log({ Quill, CustomBlockBlot });
class CustomQuillListItemModule extends ListItemFormat {
  constructor(quill, options) {
    super(quill, options);
    if (quill?.getAttribute('block-start')) {
      const blockStart = Number(quill?.getAttribute('block-start')) + 1;
      quill.setAttribute('block-start', blockStart);
      quill.style.setProperty('--block-start', blockStart);
    }
  }

  format(name, value) {
    super.format(name, value);
    // super.format('listItem', 'true');
    if (name === 'block-start') {
      this.domNode.setAttribute('block-start', value);
    }
  }

  formatAt(...rest) {
    const currentFormats = this.formats();
    if (Object.keys(currentFormats).length >= 7) { // TODO : Increase count as the number of block level formats increase
    if (this.children.tail?.text === undefined && blockFormats.includes(rest[2])) {
      if (rest[0] === 0) {
        this.format(`block-${rest[2]}`, `${rest[3]}`);
      }
    }
    }
    return super.formatAt(...rest);
  }

  remove () {
    const blockRemove = this?.attributes?.attributes?.['block-start']?.remove;
    if (blockRemove) {
      blockRemove(this.domNode);
    }
    super.remove();
  }
}

CustomQuillListItemModule.blotName = ListItemFormat.blotName;
CustomQuillListItemModule.scope = ListItemFormat.scope;
CustomQuillListItemModule.tagName = ListItemFormat.tagName;
CustomQuillListItemModule.defaultChild = ListItemFormat.defaultChild;
CustomQuillListItemModule.allowedChildren = ListItemFormat.allowedChildren;

const CustomBlocks = {
  CustomBreakBlot,
  CustomBlockBlot,
  CustomFontAttributor,
  CustomQuillListItemModule
}

export default CustomBlocks;
